export const MORNING_HOUR = 6;
export const EVENING_HOUR = 19;

/**
 * Maximum allowed characters as the message body.
 *
 * @type {number}
 */
export const MAX_LENGTH = 2500;

/**
 * Maximum allowed files attached to a message.
 * @type {number}
 */
export const MAX_FILES = 20;

/**
 * Represents the default upload config for filerr attachments.
 *
 * @type {Object}
 */
export const DEFAULT_UPLOAD_CONFIG = {
    objectName: 'message',
    attachmentName: 'attachments',
    getPolicyUrl: '/messages/policy',
    createPendingAttachmentIdUrl: '/messages/create_pending_attachment',
    shouldBeRenamed: false
};

export const NATIVE_APP_URL = 'https://fiverr.onelink.me/3732212665';

export const STATS_METRIC_PREFIX = 'packages.send_message_package';

export const STEPS = {
    MESSAGE_FORM: 'message_form',
    THANK_YOU: 'thank_you',
    LOADING: 'loading',
    OFFER_MORE_GIGS: 'offer_more_gigs'
};

export const BODY_STEPS = [
    { id: STEPS.MESSAGE_FORM },
    { id: STEPS.THANK_YOU },
    { id: STEPS.LOADING },
    { id: STEPS.OFFER_MORE_GIGS }
];
